import AbstractApiActionTypes from "services/cores/abstractApiActionTypes";

class DisplaysActionTypes extends AbstractApiActionTypes {
  SET_AUTO_REFRESH = "displays/SET_AUTO_REFRESH";
  SET_SELECTED_LAYERS = "displays/SET_SELECTED_LAYERS";
}

export default new DisplaysActionTypes("displays");
